var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/images/7_criteres.svg": "9381",
	"./assets/images/blog/code.jpg": "9021",
	"./assets/images/code.jpg": "2171",
	"./assets/images/office.jpg": "0bec",
	"./assets/images/paperpaperpaper.jpg": "f1ce",
	"./assets/images/partners-background.jpg": "e012",
	"./assets/images/partners/brother.png": "120d",
	"./assets/images/partners/canon.png": "ffe7",
	"./assets/images/partners/epson.png": "0737",
	"./assets/images/partners/fujitsu.png": "8a86",
	"./assets/images/partners/hp.png": "206d",
	"./assets/images/partners/kmbs.png": "7ba9",
	"./assets/images/partners/kyocera.png": "e190",
	"./assets/images/partners/lexmark.png": "b0da",
	"./assets/images/partners/neopost.png": "0573",
	"./assets/images/partners/panasonic.png": "161b",
	"./assets/images/partners/samsung.png": "a13e",
	"./assets/images/partners/square-9.png": "22a7",
	"./assets/images/partners/xerox.png": "9801",
	"./assets/images/partners/zebra.png": "f051",
	"./assets/images/rays.jpg": "0112",
	"./assets/images/rays.png": "615a",
	"./assets/images/rays.svg": "edf8",
	"./assets/logo.png": "cf05",
	"./assets/logos/favicon.ico": "af90",
	"./assets/logos/k-logo-white.svg": "9619",
	"./assets/logos/k-logo.svg": "a30a",
	"./assets/logos/klix_carto.wmf.svg": "914c",
	"./assets/logos/logo-navbar.ico": "c6d2",
	"./assets/logos/logo-navbar.png": "6485",
	"./assets/logos/logo.png": "e441",
	"./assets/logos/logo.svg": "df2f",
	"./assets/logos/skan_logo_no_bg.png": "dfe6",
	"./assets/logos/skan_no_bg.png": "3c9b",
	"./assets/partners-logos/brother.png": "756d",
	"./assets/partners-logos/canon.png": "1e85",
	"./assets/partners-logos/epson.png": "0fdb",
	"./assets/partners-logos/fujitsu.png": "e32c",
	"./assets/partners-logos/hp.png": "8c74",
	"./assets/partners-logos/kmbs.png": "191b",
	"./assets/partners-logos/kyocera.png": "5a5b",
	"./assets/partners-logos/lexmark.png": "bc76",
	"./assets/partners-logos/neopost.png": "7ab4",
	"./assets/partners-logos/panasonic.png": "8f64",
	"./assets/partners-logos/samsung.png": "1db7",
	"./assets/partners-logos/square-9.png": "11b7",
	"./assets/partners-logos/xerox.png": "3236",
	"./assets/partners-logos/zebra.png": "cbf7",
	"./assets/svg/404.svg": "eb2b",
	"./assets/svg/7_criteres.svg": "7195",
	"./assets/svg/ECM.svg": "a42c",
	"./assets/svg/arrow_left.svg": "2031",
	"./assets/svg/arrow_right.svg": "83e9",
	"./assets/svg/automate.svg": "c8c0",
	"./assets/svg/automation.svg": "0bc7",
	"./assets/svg/cabinet.svg": "064a",
	"./assets/svg/call_center.svg": "3cc5",
	"./assets/svg/docs.svg": "7c4a",
	"./assets/svg/eDocs.svg": "3b66",
	"./assets/svg/eDocuments.svg": "0122",
	"./assets/svg/hand-holding-usd-solid.svg": "8567",
	"./assets/svg/meeting.svg": "c56f",
	"./assets/svg/office.svg": "9ebd",
	"./assets/svg/paper-cabinet.svg": "2d44",
	"./assets/svg/paper-cabinets.svg": "c526",
	"./assets/svg/robot.svg": "df9e",
	"./assets/svg/security.svg": "fde2",
	"./assets/svg/self-serve.svg": "aff9",
	"./assets/svg/stack.svg": "b7fb",
	"./assets/svg/team.svg": "58d0",
	"./assets/svg/training.svg": "c852",
	"./assets/svg/woman_searches.svg": "1bb6",
	"./components/Contact": "371a",
	"./components/Contact.vue": "371a",
	"./components/Ebook": "be0e",
	"./components/Ebook.vue": "be0e",
	"./components/FAQ": "d2c1",
	"./components/FAQ.vue": "d2c1",
	"./components/Footer": "fd2d",
	"./components/Footer.vue": "fd2d",
	"./components/Header": "0418",
	"./components/Header.vue": "0418",
	"./components/Intro": "a380",
	"./components/Intro.vue": "a380",
	"./components/Navbar": "d178",
	"./components/Navbar.vue": "d178",
	"./components/NotFound": "be4d",
	"./components/NotFound.vue": "be4d",
	"./components/Partners": "f5e5",
	"./components/Partners.vue": "f5e5",
	"./components/Section": "bbf6",
	"./components/Section.vue": "bbf6",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "41cb",
	"./router.js": "41cb",
	"./store": "c0d6",
	"./store.js": "c0d6",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/LegalNotes": "bc80",
	"./views/LegalNotes.vue": "bc80",
	"./views/NotFound": "9703",
	"./views/NotFound.vue": "9703",
	"./views/Partners": "1a8c",
	"./views/Partners.vue": "1a8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";